$ = require 'jquery'
_ = require 'underscore'
Auth = require 'db/auth'
Controller = require 'controller'
localizeCount = require 'lib/localize-count'
ModelLoader = require 'db/model-loader'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
Util = require 'lib/util'
View = require 'view'
l = require 'lib/localize'
t = require('views/internal/teacup-with-helpers')('board_power_ups')
track = require 'debug/track'
trackUe = require 'debug/trackUe'
getExperiment = require 'lib/experiments/simple-test'

class PowerUpsAddBoardToTeam extends View
  initialize: ->
    me = Auth.me()
    @listenTo me.organizationList, "add remove reset change", @frameDebounce @render
    @createNewTeam = me.organizationList.length == 0

  events: ->
    'click .js-team': 'clickTeam'
    'click .js-create-team': 'clickCreateTeam'
    'click .js-create': 'clickCreateNewTeam'
    'click .js-cancel': 'clickCancelNewTeam'

  render: ->
    @$el.html t.render =>
      if @createNewTeam
        memberCount = @model.memberList.length
        t.div '.create-team', ->
          t.p ->
            t.format 'first-create-your-business-class-team'

          t.p ->
            t.label ->
              t.format 'team-name'
              options =
                if memberCount == 1
                  { value: t.l("names-projects", { name: Auth.me().get('fullName') }, { raw: true }) }
                else if memberCount == 2
                  { placeholder: t.l("eg-names-projects", { name: Auth.me().get('fullName') }, { raw: true }) }
                else
                  {}
              options.maxLength = 100

              t.input '.full.js-autofocus.js-name', options

            if memberCount > 1
              t.label '.create-team-add-members', =>
                t.input '.js-add-members', { type: 'checkbox', checked: true }
                t.format 'add-the-members-of-this-board-to-the-team'

          t.div ->
            t.button '.primary.js-create', ->
              t.format 'create'

            t.a '.create-team-cancel.js-cancel', { href: '#' }, ->
              t.format 'cancel'

          t.hr()

        _.defer => @$('.js-name').select().focus()

      else
        orgs = Auth.me().organizationList.sortBy((org) -> org.get('displayName').toLowerCase())

        t.div '.assign-to-team', ->
          t.p ->
            t.format 'this-board-is-not-in-a-team-yet'
            t.text ' '
            t.format 'please-select-a-team-or-create-a-new-team-to-upgrade'

        if orgs.length > 0
          t.ul '.assign-to-team-list', =>
            for org in orgs
              data =
                if org.canAddBoard(@model)
                  class: 'js-team'
                  'data-idOrganization': org.id
                else
                  class: 'disabled'
                  title: t.l 'team-restrictions-prevent-you-from-adding-this-board-to-this-team'

              t.li '.assign-to-team-list-item', data, ->
                t.div '.assign-to-team-list-item-content', ->
                  t.div '.assign-to-team-list-item-logo', ->
                    logoHash = org.get('logoHash')
                    if logoHash
                      t.img { src: "#{ logoDomain }/#{ logoHash }/30.png" }
                    else
                      t.span '.icon-lg.icon-organization'
                  t.div '.assign-to-team-list-item-details', ->
                    t.div '.assign-to-team-list-item-name', ->
                      t.text org.get('displayName')
                      if org.isFeatureEnabled('plugins')
                        t.text ' '
                        t.icon 'business-class', class: 'icon-business-class-color'
                    t.div '.assign-to-team-list-item-member-count', ->
                      if (memberships = org.get('memberships'))?
                        t.text localizeCount('members', memberships.length)

        t.div '.assign-to-team-create.js-create-team', ->
          t.div '.assign-to-team-create-content', ->
            t.button '.button.primary', ->
              t.format 'create-a-new-team'
    @

  clickTeam: (e) ->
    idOrg = @$(e.currentTarget).attr('data-idOrganization')
    @model.trigger 'added-to-team'
    Promise.fromNode (next) =>
      @model.update 'idOrganization', idOrg, { waitForServer: true }, next
    .then =>
      Controller.navigate Controller.getBoardPowerUpsUpgradeUrl(@model), { trigger: true }
    .done()

  clickCreateTeam: (e) ->
    @createNewTeam = true
    @render()

  clickCancelNewTeam: (e) ->
    Util.stop(e)
    @createNewTeam = false
    @model.trigger 'cancel-add-to-team'

  clickCreateNewTeam: (e) ->
    name = @$('.js-name').val()
    if !/\S/.test(name)
      return

    data =
      displayName: name

    @$('.js-create,.js-cancel')
    .prop('disabled', true)
    .addClass('disabled')

    Auth.me().organizationList.create data, {
      @modelCache
      silent: true
      success: (data) =>
        idOrg = data.id
        @model.trigger 'added-to-team'
        @model.update('idOrganization', idOrg, { waitForServer: true })

        ModelLoader.loadOrganizationMembersMinimal(idOrg)
        .then =>
          if @$('.js-add-members').prop('checked')
            org = @model.getOrganization()

            track("New Org", "Create", "Power-Ups Sidebar (with members)", data.id)

            Promise.map @model.memberList.models, (member) =>
              if !org.isMember(member)
                org.changeMemberRole(member, { type: 'normal' })
            , { concurrency: 3 }
          else
            track("New Org", "Create", "Power-Ups Sidebar (without members)", data.id)
        .then =>
          Controller.navigate Controller.getBoardPowerUpsUpgradeUrl(@model), { trigger: true }
        .done()
    }

class PowerUpsForTeamMembers extends View
  vigor: @VIGOR.NONE
  renderOnce: ->
    @$el.html t.render =>
      t.div '.count-explanation', =>
        t.p =>
          t.format 'only-team-members-can-enable-power-ups'

class PowerUpsLimitAd extends View
  className: 'power-ups-limit-reached'

  events:
    'click .js-upgrade-team': (e) ->
      track("Power-Ups Menu", "Banner Ad", "Get More Power-Ups Button")
    'click .power-ups-limit-reached-learn-more': ->
      track("Power-Ups Menu", "Banner Ad", "Learn More Link")

  vigor: @VIGOR.NONE
  renderOnce: ->
    upgradeUrl = Controller.getBoardPowerUpsUpgradeUrl(@model)
    adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')
    me = Auth.me()

    html = t.render =>
      t.p '.power-ups-limit-reached-message', ->
        t.format 'it-looks-like-youve-reached-your-power-ups-limit-for-this-board'

      t.p '.power-ups-limit-reached-sub', ->
        t.format 'business-class-teams-get-unlimited-power-ups'

      t.p '.power-ups-limit-reached-sub', { style: 'margin: 8px 40px' }, ->
        t.format 'to-unlock-more-upgrade-to-business-class-today'

      t.p '.power-ups-limit-reached-button', =>
        if @model.hasOrganization()
          t.a '.button.primary.js-upgrade-team', { href: upgradeUrl }, ->
            t.format 'lets-do-this'
        else
          t.a '.button.primary.js-add-to-team', { href: '#' }, ->
            t.format 'lets-do-this'

      t.a '.power-ups-limit-reached-no-thanks.js-no-thanks', { href: '#' }, ->
        t.format 'no-thanks'

    experimentHtml = t.render =>
      t.div '.power-ups-ad-body', =>
        t.p '.power-ups-ad-title', ->
          t.format 'ads-title'
        t.p '.power-ups-ad-text', ->
          t.format 'ads-text'
        t.a '.power-ups-ad-learn-more', { href: '/business-class', target: '_blank' }, ->
          t.format 'ads-learn-more'

        t.p '.power-ups-limit-reached-button', =>
          if @model.hasOrganization()
            t.a '.button.primary.js-upgrade-team', { href: upgradeUrl }, ->
              t.format 'ads-upgrade'
          else
            t.a '.button.primary.js-add-to-team', { href: '#' }, ->
              t.format 'ads-upgrade'

    if adsLayoutExperimentEnabled
      @$el
        .addClass 'ads-layout-experiment'
        .html experimentHtml
    else
      @$el.html html

spinnerTemplate = t.renderable ->
  t.div ->
    t.div '.spinner.loading'

class PowerUpsSpinnerView extends View
  render: ->
    @$el.html(spinnerTemplate())
    @

module.exports = class PluginEnablePopOver extends View
  viewTitleKey: 'power ups'
  noPadding: true

  className: 'plugin-enable-pop-over'

  initialize: ({ @plugin }) ->
    @listenTo @model, 'cancel-add-to-team', =>
      @addToTeam = false
      @render()
    @listenTo @model, 'added-to-team', =>
      @redirecting = true
      @render()

    @redirecting = false
    @addToTeam = false

  events: ->
    'click .js-add-to-team': (e) ->
      Util.stop(e)
      if !@model.owned()
        # We aren't an admin on this board so redirect to business-class page
        window.location = '/business-class'
      else
        @addToTeam = true
        @render()

    'click .js-no-thanks': (e) ->
      Util.stop(e)
      PopOver.hide()

  render: ->
    @$el.empty()

    if @redirecting
      @renderSpinner()
    else if @addToTeam
      @renderAddToTeam()
    else
      trackUe('card-detail', 'opens', 'BC upgrade dialog', '', '', 'enable button', @plugin.id)
      @renderLimitAd()

    @

  renderSpinner: ->
    @appendSubview @subview(PowerUpsSpinnerView, @model)
    return @

  renderAddToTeam: ->
    if @model.hasOrganization()
      # So the board is part of a team, we just can't see it
      # This is a weird situation; we're just not going to let them
      # mess with the power-ups in this case
      @appendSubview @subview(PowerUpsForTeamMembers, @model)
      return @

    ModelLoader.loadMyOrganizations()

    @appendSubview @subview(PowerUpsAddBoardToTeam, @model)

  renderLimitAd: ->
    @appendSubview @subview(PowerUpsLimitAd, @model)



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-enable-pop-over.coffee